export const useNetSuiteProduction = 'true';
export const useNetSuiteProductionRfq = 'true';
export const mapboxKey = 'pk.eyJ1IjoiY2FyYXdheWptIiwiYSI6ImNsdG50MXl1ejA3cG4yaXBhOGZqenE3b2kifQ.ultVo_AWldm3xzQKi0F-xw';
